import http from './http';
import { OK } from '../utils/constant';

const TwoFAService = {
    /**
     * Enable 2FA for a user
     * @param {Object} data - { user_id, two_factor_method }
     */
    enableTwoFA: async (data) => {
        try {
            const response = await http.POST(`two_factor/enable`, data);
            if (response.code === OK && response.data) {
                return response.data;
            }
            return response;
        } catch (error) {
            console.error('Error enabling 2FA:', error);
            throw error;
        }
    },
    toggleTwoFA:async(data)=>{  
        try{
            const response = await http.POST(`two_factor/toggleDisabled`, data);
            if (response.code === OK && response.data) {
                return response;
            }
            return response;
        }catch(error){  
            console.error('Error toggling 2FA:', error);
            throw error;
        }
    },
    getEnabledTwoFAMethods:async(userId)=>{
        try{
            const response = await http.GET(`two_factor/getEnabledTwoFAMethods/${userId}`);
            if (response.code === OK && response.data) {
                return response;
            }
            return null;
        }catch(error){
            console.error('Error enabling 2FA:', error);
            throw error;
        }
    },
    /**
     * Disable 2FA for a user
     * @param {Object} data - { user_id }
     */
    disableTwoFA: async (data) => {
        try {
            const response = await http.POST(`two_factor/disable`, data);
            if (response.code === OK && response.data) {
                return response.data;
            }
            return response;
        } catch (error) {
            console.error('Error disabling 2FA:', error);
            throw error;
        }
    },

    /**
     * Verify 2FA code
     * @param {Object} data - { user_id, code }
     */
    verifyTwoFA: async (data) => {
        try {
            const response = await http.POST(`two_factor/verify`, data);
            if (response.code === OK && response.data) {
                return response;
            }
            return response;
        } catch (error) {
            console.error('Error verifying 2FA:', error);
            throw error;
        }
    },

    /**
     * Get user’s 2FA status
     * @param {String} userId - User ID
     */
    getTwoFAStatus: async (userId) => {
        try {
            const response = await http.GET(`two_factor/status/${userId}`);
            if (response.code === OK && response.data) {
                return response.data;
            }
            return null;
        } catch (error) {
            console.error('Error fetching 2FA status:', error);
            throw error;
        }
    },
    GetVerifcicationData:async (id) =>{
        try {
            const response = await http.GET(`two_factor/getEnabledTwoFAMethods/${id}`);
            console.log(response);
            if (response.code === OK && response.data) {
                return response.data;
            }
            return null;
        } catch (error) {
            console.error('Error fetching 2FA status:', error);
            throw error;
        }
    },
    getTwoFALoginCode: async (data) =>{
        try {
            const response = await http.POST(`two_factor/getTwoFALoginCode`,data);
            console.log(response);
            if (response.code === OK && response.data) {
                return response.data;
            }
            return null;
        } catch (error) {
            console.error('Error fetching 2FA status:', error);
            throw error;
        }
    },
    delete2FA:async (data) =>{
        try{
            const response = await http.POST(`two_factor/delete-verify-password`,data);
            if (response.code === OK && response) {
                return response;
            }
            return null;
        }catch(error){
            console.error('Error deleting 2FA:', error);
            throw error;
        }
    },
    destroy2FA:async (data)=>{
        try{
            const response = await http.POST(`two_factor/destroy`,data);
            console.log(response);
            if (response.code === OK && response) {
                return response;
            }
            return null;
        }catch(error){
            console.error('Error deleting 2FA:', error);
            throw error;
        }
    },
    lockUserAccount:async (data) => {
        try{
            const response = await http.POST(`lock-user-account`,data);
            console.log(response);
            if (response.code === OK && response) {
                return response;
            }
            return null;
        }catch(error){
            console.error('Error lock user account:', error);
            throw error;
        }
    }
};

export default TwoFAService;
